import { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { Link } from "react-router-dom";

const ProductDetail = () => {
  const [quantity, setQuantity] = useState(1);

  const product = {
    title: "Salad Tuna",
    subtitle: "(Must choose level)",
    price: 10.99,
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.",
    image: "https://via.placeholder.com/600x400.png?text=Salad+Tuna",
  };

  const handleIncrement = () => setQuantity((q) => q + 1);
  const handleDecrement = () => setQuantity((q) => (q > 1 ? q - 1 : 1));

  return (
    <div className="min-h-screen relative bg-gray-100 flex flex-col pb-20">
     

      {/* Product Image */}
      <div className="relative px-4 mt-3">
        <img
          src={product.image}
          alt={product.title}
          className="rounded-2xl w-full object-cover h-64 shadow"
        />
        <button className="absolute top-3 left-6 bg-white p-2 rounded-full shadow text-lg">
          ←
        </button>
      </div>

      {/* Product Info */}
      <div className="px-4 mt-5">
        <h1 className="text-xl font-semibold text-gray-800">
          {product.title}
        </h1>
        <p className="text-sm text-gray-500 mt-1">{product.subtitle}</p>

        <div className="flex justify-between items-center mt-4">
          <p className="text-2xl font-bold text-primary">${product.price}</p>
          <div className="flex items-center bg-primary text-white rounded-full overflow-hidden shadow text-sm">
            <button
              onClick={handleDecrement}
              className="px-3 py-2  transition"
            >
              <FiMinus />
            </button>
            <span className="px-4 py-2 bg-white text-primary font-semibold">
              {quantity}
            </span>
            <button
              onClick={handleIncrement}
              className="px-3 py-2  transition"
            >
              <FiPlus />
            </button>
          </div>
        </div>

        <p className="text-sm text-gray-600 mt-4 leading-relaxed">
          {product.description}
        </p>
      </div>

      {/* Other Items */}
      <div className="px-4 mt-6">
        <h2 className="text-base font-semibold mb-3 text-gray-800">
          Other Items In The Category
        </h2>
        <div className="flex gap-4 overflow-x-auto pb-2">
          {[1, 2, 3].map((_, i) => (
            <div
              key={i}
              className="bg-white rounded-xl shadow-md w-44 min-w-[11rem] flex-shrink-0"
            >
              <img
                src={product.image}
                alt="Product"
                className="rounded-t-xl w-full h-24 object-cover"
              />
              <div className="p-3">
                <h4 className="text-sm font-semibold text-gray-800">
                  {product.title}
                </h4>
                <p className="text-xs text-gray-400">{product.subtitle}</p>
                <div className="flex justify-between items-center mt-2">
                  <span className="text-primary font-bold text-sm">
                    ${product.price}
                  </span>
                  <button className="text-primary border border-red-600 text-xs font-bold rounded-full px-3 py-1 hover:bg-red-50 transition">
                    + Add
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fixed Bottom Bar */}
      <Link to="/cartDetail" className="absolute bottom-0 left-0 w-full bg-primary text-white text-center py-4 text-sm sm:text-base font-semibold shadow-md">
        Go To Cart - ${parseFloat(product.price * quantity).toFixed(2)}
      </Link>
    </div>
  );
};

export default ProductDetail;
